module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Light.30778183.ttf";